import { render, staticRenderFns } from "./Apps.vue?vue&type=template&id=d3714d0a&"
import script from "./Apps.vue?vue&type=script&lang=js&"
export * from "./Apps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/admin/Docker/server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3714d0a')) {
      api.createRecord('d3714d0a', component.options)
    } else {
      api.reload('d3714d0a', component.options)
    }
    module.hot.accept("./Apps.vue?vue&type=template&id=d3714d0a&", function () {
      api.rerender('d3714d0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "apps/settings/src/views/Apps.vue"
export default component.exports